/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Preview/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Details from './Details/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import UnsetAction from './UnsetAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Preview({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/ReferralSource/Content/Content/Referrals/Referral/Source/Search/Preview"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<div
  data-testid="Preview.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-1Af4GC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Preview.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Source"
 color={dtColorsBlack}
 weight="medium"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="*"
 marginLeft={dtSpaceXxxs}
 color={dtColorsRed600}
 opacity={1}
/>
</div>
<div
  data-testid="Preview.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-2-1Af4GC': dtColorsWhite,'--btlr-3-1Af4GC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-1Af4GC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-5-1Af4GC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-6-1Af4GC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-7-1Af4GC': dtColorsNeutral300,'--pl-8-1Af4GC': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-9-1Af4GC': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pt-10-1Af4GC': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-11-1Af4GC': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Details
  viewPath={`${viewPath}/Details`}
/>
<UnsetAction
  viewPath={`${viewPath}/UnsetAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}